import { approvals } from "./approvals/approvals";
import { bankForwardPay } from "./payments/bankForwardPay";
import { requests } from "./requests/requests";
import { prepayments } from "./prepayments/prepayments";
import { employeesList } from "./employees/employeesList";
import { detailedTaxes } from "./payments/detailedTaxes";
import { suspensions } from "./employees/suspensions";
import { employeesLeave } from "./employees/employeesLeave";
import { clockingTypesReports } from "./clockingTypesReports/clockingTypesReports";
import { openForgottenShifts } from "./attendance/openForgottenShifts";
import { missingPunches } from "./attendance/missingPunches";
import { otBank } from "./attendance/otBank";
import { hoursCostByDept } from "./attendance/hoursCostByDept";
import { plannedVsActual } from "./attendance/plannedVsActual";
import { leaveBalance } from "./leave/leaveBalance";
import { leaveCoverage } from "./leave/leaveCoverage";

export const processFactory = (
  type,
  data,
  filter,
  definitions,
  manualColumns,
  other,
) => {
  switch (type) {
    case "approvals":
      return approvals(data, filter, definitions, manualColumns, other);
    case "supervisorApprovals":
      return approvals(data, filter, definitions, manualColumns);
    case "clockingTypesReports":
      return clockingTypesReports(
        data,
        filter,
        definitions,
        manualColumns,
        other,
      );
    case "openForgottenShifts":
      return openForgottenShifts(
        data,
        filter,
        definitions,
        manualColumns,
        other,
      );
    case "missingPunches":
      return missingPunches(data, filter, definitions, manualColumns, other);
    case "otBank":
      return otBank(data, filter, definitions, manualColumns, other);
    case "hoursCostByDept":
      return hoursCostByDept(data, filter, definitions, manualColumns, other);
    case "plannedVsActual":
      return plannedVsActual(data, filter, definitions, manualColumns, other);
    case "leaveBalance":
      return leaveBalance(data, filter, definitions, manualColumns, other);
    case "leaveCoverage":
      return leaveCoverage(data, filter, definitions, manualColumns, other);
    case "requests":
      return requests(data, filter, definitions, manualColumns);
    case "bankForwardPay":
      return bankForwardPay(data, filter, definitions, manualColumns);
    case "prepayments":
      return prepayments(data, filter, definitions, manualColumns);
    case "employeesList":
      return employeesList(data, filter, definitions, manualColumns);
    case "detailedTaxes":
      return detailedTaxes(data, filter, definitions, manualColumns);
    case "suspensions":
      return suspensions(data, filter, definitions, manualColumns);
    case "employeesLeave":
      return employeesLeave(data, filter, definitions, manualColumns);
    default:
      return null;
  }
};
